import React from 'react';
import { photos, spaceFacts } from '../data/site';
export function Institute() {
  return <section id="institut" aria-labelledby="institut-title" className="bg-white py-20 lg:py-28" data-id="element-71" data-mp="ipktlvpecj1h">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-72" data-mp="40onw5atbi41">
        <div className="lg:col-span-5 lg:pt-6" data-id="element-73" data-mp="8yzy4h50rums">
          <h2 id="institut-title" className="font-serif text-4xl font-medium leading-tight text-ink lg:text-5xl" data-id="element-74" data-mp="8xouqifhkow7">
            Un havre de bien-être, pensé dans les moindres détails
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-75" data-mp="3v816morcg3m2">
            Sous la direction de Noushine, notre institut allie savoir-faire artisanal et technologies de pointe pour des
            résultats visibles et durables. Après votre soin, prolongez le moment dans notre espace repos, autour d’une
            infusion.
          </p>

          <dl className="mt-10 divide-y divide-line border-y border-line" data-id="element-76" data-mp="1keevvn51yqiy">
            {spaceFacts.map(f => <div key={f.label} className="grid grid-cols-[88px_1fr] items-baseline gap-4 py-4" data-id="element-77" data-mp="lsf2lk8xlsgm">
                <dt className="font-serif text-3xl text-ink" data-id="element-78" data-mp="gudo7cmgahbh">{f.value}</dt>
                <dd className="text-muted" data-id="element-79" data-mp="ul8ymtcll6h6">{f.label}</dd>
              </div>)}
          </dl>

          <a href="https://commeuncharme.fr/a-propos" className="mt-8 inline-block font-bold text-sage underline decoration-sage/30 underline-offset-4 transition-colors duration-150 hover:decoration-sage" data-id="element-80" data-mp="qjncehe6bfub">
            Découvrir notre histoire
          </a>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:col-span-7" data-id="element-81" data-mp="buiwx7yrjppw">
          <figure className="row-span-2" data-id="element-82" data-mp="bw29ool7nimx">
            <img src={photos.hammam} alt="Le hammam de l'institut" className="h-full w-full rounded-sm object-cover" data-id="element-83" data-mp="6v6aupfpumod" />
          </figure>
          <figure data-id="element-84" data-mp="1n8cvuc5g8gie">
            <img src={photos.cabine} alt="Une cabine de soins" className="aspect-[4/5] w-full rounded-sm object-cover" data-id="element-85" data-mp="1nc0s3j2a3h0t" />
          </figure>
          <figure data-id="element-86" data-mp="fxycdbstr3ds">
            <img src={photos.repos} alt="L'espace repos et son infusion" className="aspect-[4/5] w-full rounded-sm object-cover" data-id="element-87" data-mp="fwdjdqm5rsi1" />
          </figure>
        </div>
      </div>
    </section>;
}